'use client';
import { useEffect, useState } from 'react';
import { PROMO_BAR_HEIGHT as BANNER_HEIGHT } from '@web/molecules/Header/RotatingPromoBar/styles';

// Nav is always position:fixed (out of flow), so it can't rely on native
// position:sticky flow-tracking to slide up as a non-sticky banner scrolls
// past above it, so we track scroll position manually.
export const useNavTopOffset = (
  enabled = false,
  hasBanner = false,
  stickyBanner = false,
) => {
  const [offset, setOffset] = useState(hasBanner ? BANNER_HEIGHT : 0);

  useEffect(() => {
    if (!enabled || !hasBanner || stickyBanner) {
      setOffset(hasBanner && stickyBanner ? BANNER_HEIGHT : 0);
      return;
    }

    const check = () => {
      // A scroll lock (e.g. SlidingContainer's open drawer) clamps
      // window.scrollY to 0 and fires a scroll event as a side effect,
      // even though the user hasn't actually scrolled back to the top.
      // Skip recomputing until the lock is released to avoid the nav
      // jumping down while it's engaged.
      if (document.body.dataset.scrollLocked) return;
      setOffset(Math.max(0, BANNER_HEIGHT - window.scrollY));
    };

    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });

    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [enabled, hasBanner, stickyBanner]);

  return offset;
};
